<h1 mat-dialog-title>¿Estás seguro de que quieres salir de la edición?</h1>
<h6>Todos los cambios serán borrados</h6>
<div mat-dialog-actions>
    <button class="cancel-button" mat-button [mat-dialog-close]>Cancel</button>
    <button class="delete-button" mat-button [mat-dialog-close]="true">Exit</button>
</div>

